import React, { useRef } from 'react';
import { Button, message } from 'antd';
import { ModalForm, ProFormText, ProFormSelect } from '@ant-design/pro-form';
import { PlusOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client';
import { GET_PROJECT_CATEGORIES } from '../../../gql/projectCategories';
import { GET_PROJECTS, ADD_PROJECT } from '../../../gql/projects';
import { PrivateComponent } from 'components/auth';
import { useHistory } from 'react-router-dom';

const AddProjectModal = (props) => {
  const formRef = useRef();
  const history = useHistory();
  const { actionRef } = props;
  const { data, loading } = useQuery(GET_PROJECT_CATEGORIES, {
    variables: { state: 'ACTIVE' },
  });
  const [addProjectMutation] = useMutation(ADD_PROJECT, {
    refetchQueries: [{ query: GET_PROJECTS, variables: { status: 'ALL' } }],
    onCompleted: ({ addProject }) => {
      actionRef?.current?.reload();
      history.push(`/projects/${addProject.id}/profile`);
    },
  });

  const options = loading
    ? []
    : data.projectCategories.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
  return (
    <PrivateComponent expectedScopeType={['WRITE_PROJECT']}>
      <ModalForm
        formRef={formRef}
        title="Add Project"
        trigger={
          <Button type="primary">
            <PlusOutlined />
            Add Project
          </Button>
        }
        onFinish={async ({ title, projectCategory }) => {
          const {
            data: { addProject },
          } = await addProjectMutation({
            variables: {
              input: {
                title,
                projectCategory,
              },
            },
          });
          if (formRef.current) {
            formRef.current.resetFields();
          }
          message.success(`${addProject.title} added successfully`);
          return true;
        }}
        submitter={{
          searchConfig: {
            resetText: 'Back',
            submitText: 'Submit',
          },
        }}
      >
        <ProFormText
          width="xl"
          name="title"
          label="Project Title"
          placeholder="enter project title"
          rules={[
            {
              required: true,
              message: 'Please enter project title!',
            },
          ]}
        />
        <ProFormSelect
          options={options}
          width="xl"
          name="projectCategory"
          label="Project Category"
          placeholder="select"
          rules={[
            {
              required: true,
              message: 'Please select!',
            },
          ]}
        />
      </ModalForm>
    </PrivateComponent>
  );
};

export default AddProjectModal;
